import type { TChatSuggestion } from '@cascade/ui-library';

export const buildSuggestions = (prompts: string[]): TChatSuggestion[] =>
  prompts.map((prompt) => ({ prompt }));
